import React from 'react';

import MandatorySymbol from 'components/ui/MandatorySymbol';

const MandatoryWarning: React.FC = () => (
  <div className="flex pt-2 kiosk:pt-4 items-center kiosk:mb-5 kiosk:px-5">
    <span className="relative p-0.5 after:absolute after:content-[''] after:rounded-full after:w-full after:h-full after:border-2 after:border-danger-high after:bottom-1 after:left-0 after:animate-ping mr-6 flex items-center justify-center text-xl! kiosk:text-2xl!">
      <MandatorySymbol className="mx-1" />
    </span>
    <div className="w-full">
      <div className="h-1 rounded-3xl bg-overlay" />
      <div className="w-1/2 h-1 mt-2 rounded-3xl bg-overlay" />
    </div>
  </div>
);

export default MandatoryWarning;
